import { render, staticRenderFns } from "./LLSelectInputNew.vue?vue&type=template&id=2183a0dd&scoped=true"
import script from "./LLSelectInputNew.vue?vue&type=script&lang=js"
export * from "./LLSelectInputNew.vue?vue&type=script&lang=js"
import style0 from "./LLSelectInputNew.vue?vue&type=style&index=0&id=2183a0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183a0dd",
  null
  
)

export default component.exports